import {Button} from "react-bootstrap";
import SchedulerActionLabel from "./SchedulerActionLabel";

export default function SchedulerMobileCardAction({
    disabled = false,
    isLoading = false,
    label,
    onClick,
    size = "sm",
    title,
    variant = "primary",
}) {
    return (
        <Button
            className="scheduler-mobile-card-action"
            type="button"
            variant={variant}
            size={size}
            disabled={disabled || isLoading}
            aria-busy={isLoading}
            title={title}
            onClick={(event) => {
                event.stopPropagation();
                onClick();
            }}
        >
            <SchedulerActionLabel isLoading={isLoading}>{label}</SchedulerActionLabel>
        </Button>
    );
}
